module.exports = __webpack_public_path__ + "static/media/newretail_bg.89068236.png";